
import { SAMPLE_VIDEOS } from '@/pages/dashboard/sampleData';

export type VideoStatus = 'processing' | 'processed' | 'failed';

export interface Video {
  id: string;
  title: string;
  description: string;
  thumbnailUrl: string;
  videoUrl: string;
  uploadDate: string;
  duration: number;
  views: number;
  plays: number;
  likes: number;
  folderId: string | null;
  status: VideoStatus;
  tags: string[];
  createdAt?: string;
  isNew?: boolean;
  isProcessing?: boolean;
  processingProgress?: number;
  viewCount?: number;
}

export interface Folder {
  id: string;
  name: string;
  color: string;
  emoji: string;
  count: number;
  createdAt: string;
}

export type ViewMode = 'grid' | 'list';

// Sample folders for reference
export const SAMPLE_FOLDERS: Folder[] = [
  {
    id: 'all',
    name: 'All Videos',
    color: '#6366f1',
    emoji: '🎬',
    count: 0,
    createdAt: new Date().toISOString()
  },
  {
    id: 'recent',
    name: 'Recent',
    color: '#ec4899',
    emoji: '⏱️',
    count: 0,
    createdAt: new Date().toISOString()
  }
];

export type DensityMode = 'comfortable' | 'compact';

export interface VideoDashboardStore {
  videos: Video[];
  folders: Folder[];
  activeFolder: string | null;
  viewMode: ViewMode;
  searchQuery: string;
  statusFilter: 'all' | 'processing' | 'processed' | null;
  densityMode: DensityMode;
  
  // Folder actions
  addFolder: (name: string, options?: { color?: string; emoji?: string }) => string;
  renameFolder: (id: string, name: string) => void;
  deleteFolder: (id: string) => void;
  moveVideoToFolder: (videoId: string, folderId: string | null) => void;
  setActiveFolder: (folderId: string | null) => void;
  recalculateFolderCounts: () => void;
  
  // View and filter actions
  setViewMode: (mode: ViewMode) => void;
  setSearchQuery: (query: string) => void;
  setStatusFilter: (status: 'all' | 'processing' | 'processed' | null) => void;
  setDensityMode: (mode: DensityMode) => void;

  // Video actions
  addVideo: (video: Video) => void;
  removeVideo: (videoId: string) => void;
  updateVideo: (videoId: string, data: Partial<Video>) => void;
}
